module.exports = __webpack_public_path__ + "img/yuw.8b6a2f3b.png";